<template>
    <tabla-datos :asignaciones="true" :botones="true" :columnas="columnas" :datos="autofacturas" :filtros="false" :servicios="true" v-if="mostrar"
        :page="pageselec" :num="numdatos" :total="total" @quieroDatos="obtenerAutofacturas($event); mievento = $event;" @page="onPage($event)">
        <template #body="slotProps">
            <template v-if="slotProps.column.field === 'url_completa_factura_pdf'">
                <button 
                    @click="mostrarPdf(slotProps.data.url_completa_factura_pdf)"
                    class="p-button p-component p-button-icon-only"
                    title="Ver PDF"
                >
                    <span class="pi pi-file-pdf"></span> </button>
            </template>
        </template>
    </tabla-datos>
</template>   
<script>
import { PwgsApi } from '../../../services/PwgsApi';
import TablaDatos from '../../TablaDatos.vue';
export default {
    components: {
    
        "tabla-datos": TablaDatos,
    },
    data() {
        return {
        mievento:[],
        usuarioseleccionado:'',
        companiaseleccionada:'',
            mostrar:false,
            filtroExpediente: '',
            pageselec:1,
            numDatos:15,
            total: '',
            autofacturas: [],
            parametros: '',
            columnas: [
                {
                    header: 'Operario',
                    field: 'nombre_distribuidor',
                    sortable: false,
                },
                {
                    header: 'Fecha',
                    field: 'fecha_hoy',
                    sortable: true,
                },
                {
                    header: 'Importe',
                    field: 'total',
                    sortable: false,
                },
                {
                    header: 'Teléfono',
                    field: 'telefono_distribuidor',
                    sortable: false,
                },
                {
                    header: 'Acciones',
                    data: null,
                    acciones: [
                        {
                            nombre: 'PDF',
                            nombreId: 'url_completa_factura_pdf',
                            icono: 'far fa-file-pdf',
                            accion: (url) => {
                                this.mostrarPdf(url);
                            }
                        },
                    ]
                },
            ]
        }
    },
    methods: {
        onPage(evnt){
            localStorage.setItem("pageselecconf", evnt.page);
            localStorage.setItem("numdatsconf", evnt.rows);
        },
        async obtenerAutofacturas() {
            let tipobuscador = localStorage.getItem("tipobuscador");
            const api = new PwgsApi;
            const aux = await api.post('avisos/autovisitas',{tipo:tipobuscador});
            this.autofacturas = aux.datos;
            this.total = aux.n_total_registros;
            this.$emit('evento_total_autofacturas',this.total);
            localStorage.setItem("num_autofacturas",this.total);
        },
        mostrarPdf(urlfactura) {
            let auxurlpdf = urlfactura;
            window.open(auxurlpdf,'_blank')
        },
    },
    mounted() {
        this.pageselec = parseInt(localStorage.getItem('pageselecconf'));
        this.numdatos = parseInt(localStorage.getItem('numdatsconf'));
        this.mostrar = true;
    },
    watch:{
    
    }
}
</script>
<style>
.p-dialog {
    width: 90%;
}
.p-datatable-header{
    visibility:hidden;
}
</style>